module.exports = __webpack_public_path__ + "img/sfq3.bf9de60b.png";